
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import "./index.scss";

const DataForm = () => {

    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (nome && email) {
            Swal.fire({
                title: "Formulário enviado!",
                text: "Obrigado por se inscrever 😄",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                willClose: () => {
                    navigate("/");
                },
            });
        } else {
            Swal.fire({
                title: "Campos obrigatórios",
                text: "Preencha todos os campos antes de enviar",
                icon: "warning",
                confirmButtonText: "OK",
            });
        }
    }


    return (

        <form 
            onSubmit={handleSubmit} className="form-register">
                <h2>Formulario de Inscrição</h2>
                <input className="input-name"
                    type="text"
                    placeholder="Nome"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)} 
                />
                <input className="input-email"
                    type="email"
                    placeholder="E-maill"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)} 
                />
                <button type="submit" className="button-submit-register">Enviar</button>
        </form>

    )
        
}

export default DataForm;